/* eslint-disable */
/* GENERATED FILE - DO NOT MODIFY */
/* run yarn import-data to regenerate */
import { GridProduct, SkinProduct, MechProduct, InterfaceProduct, ProductRule, ConstantProductsShape } from "../types/productTypes"

import ClipsalData from  "./ClipsalProductData"
import PdlData from "./PdlProductData"

let data: typeof ClipsalData

switch (process.env.REACT_APP_FLAVOUR) {
  case "PDL":
    data = PdlData
    break
  default:
    data = ClipsalData
}

export const GridProducts: readonly GridProduct[] = data.GridProducts
export const SkinProducts: readonly SkinProduct[] = data.SkinProducts
export const InterfaceProducts: readonly InterfaceProduct[] = data.InterfaceProducts
export const MechProducts: readonly MechProduct[] = data.MechProducts
export const ProductRules: readonly ProductRule[] = data.ProductRules
export const ConstantProducts: ConstantProductsShape = data.ConstantProducts